import { Module } from 'vuex'
import { AuthState } from './types'
import { RootState } from '../types'
import { actions } from './actions'
import { mutations } from './mutations'

const state: AuthState = {
  user: {},
  token: '',
  certified: false
}

const namespaced = true

export const auth: Module<AuthState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
}

export default state
